import type { ToolBadgeSpec } from '../types.js';

import {
  makeListExtractor,
  queryContextLabel,
  readField,
  readString,
  truncateForLabel,
  withQueryLabel,
} from '../extractors.js';

function getQuery(toolCall: { input?: Record<string, unknown> }): string | undefined {
  return readString(readField(toolCall.input, 'search_query'));
}

const extractDestinations = makeListExtractor({
  arrayKey: 'results',
  previewType: 'destination',
  idFields: ['_id', 'id'],
  titleFields: ['displayName', 'name'],
  subtitleFields: ['address'],
});

export const fetchDestinationDataSpec: ToolBadgeSpec = {
  toolName: 'fetchDestinationData',
  aliases: ['searchDestinations'],
  icon: 'map',
  label: (toolCall, active) => {
    if (readString(readField(toolCall.input, 'search_strategy')) === 'direct_lookup') {
      const query = getQuery(toolCall);
      const base = active ? 'Fetching info for' : 'Fetched info for';
      return query ? `${base} ${truncateForLabel(query)}` : base;
    }
    return withQueryLabel(active ? 'Searching for destinations' : 'Searched for destinations', getQuery(toolCall));
  },
  activitySummary: { label: (_, active) => (active ? 'Searching for destinations' : 'Searched for destinations') },
  resultNoun: { singular: 'destination', plural: 'destinations' },
  extractResults: (toolCall) => {
    // Direct lookups return results that aren't necessarily matches for what the user
    // asked for, so the dropdown is only useful for vibe searches.
    if (readString(readField(toolCall.input, 'search_strategy')) !== 'vibe_discovery') return undefined;
    const group = extractDestinations(toolCall.output);
    if (!group) return undefined;
    return { ...group, contextLabel: queryContextLabel(getQuery(toolCall)) };
  },
};
